// account_stage = clinic.status ; subscription_status = billing status
// no pending_verification branch (email handled in-app); no boolean returned
export const getFlowDecision = (account_stage, subscription_status) => {
    const ACTIVE = ['trialing', 'active'];
    const CARD_FIX = ['past_due', 'unpaid'];

    if (ACTIVE.includes(subscription_status)) {
        if (account_stage === 'onboarding') return '/onboarding';
        if (account_stage === 'active') return '/dashboard';
        return '/onboarding'; // pending_verification, or unrecognized

    }

    if (CARD_FIX.includes(subscription_status)) return '/billing/update-card';

    return '/pricing'; // none/canceled/incomplete/incomplete_expired/paused
};



export const groupOf = (pathname) =>
      pathname.startsWith('/dashboard')  ? '/dashboard'
    : pathname.startsWith('/billing')    ? '/billing/update-card'
    : pathname.startsWith('/onboarding') ? '/onboarding'
    : '/pricing'; 
